module.exports = __webpack_public_path__ + "static/media/b3.28b86eca.jpg";